import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import type { TFunction } from 'i18next';

dayjs.extend(duration);

const agoText = (
  t: TFunction,
  unit: 'year' | 'month' | 'week' | 'day' | 'hour' | 'minute',
  count: number,
) => t(($) => $.common.elapsed[`${unit}Ago`], { count });

export function getElapsedText(date: Date, t: TFunction): string {
  const now = dayjs();
  const pastDate = dayjs(date);
  const diff = dayjs.duration(now.diff(pastDate));

  const years = diff.years();
  const months = diff.months();
  const weeks = diff.weeks();
  const days = diff.days();
  const hours = diff.hours();
  const minutes = diff.minutes();

  if (years > 0) return agoText(t, 'year', years);
  if (months > 0) return agoText(t, 'month', months);
  if (weeks > 0) return agoText(t, 'week', weeks);
  if (days > 0) return days === 1 ? t(($) => $.common.elapsed.yesterday) : agoText(t, 'day', days);
  if (hours > 0) return agoText(t, 'hour', hours);
  if (minutes > 0) return agoText(t, 'minute', minutes);

  return t(($) => $.common.elapsed.justNow);
}
